(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.tabs.feeders-tab
  (:require
   [common.localization :as loc]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.tabs.common :as common]
   [frontend.ui.component.lp-portal.section.view :as section]
   [common.schema.entities.lp-portal.lp-report :as lp-report]))

(defn fund-view
  [master-report feeder-report input-id]
  [:div
   [section/section
    (loc/tr :lp-fund-report
                     [(get lp-report/hardcoded-fund-templates
                           (:lp-report/template-type feeder-report))
                      (some-> feeder-report
                              :lp-report/data
                              :fund-name)])
    nil
    [common/fund-report-table feeder-report true input-id]]
   [section/section (loc/tr :lp-report-landing-page-data) nil
    [common/landing-page-table feeder-report]]
   [section/section (loc/tr :lp-report/materials) nil
    [common/materials-table master-report feeder-report true]]
   [section/section (loc/tr :lp-report/investors) nil
    [common/fund-investors-table feeder-report true]]])
